import type { FieldValues, Path } from "react-hook-form";

export const createFieldGroup =
	<TForm extends FieldValues>() =>
	<const TFields extends readonly Path<TForm>[]>(fields: TFields) => ({
		fields,
		depsFor: (field: TFields[number]): Path<TForm>[] =>
			fields.filter((name) => name !== field),
	});
